import { API_BASE_URL } from "../../constants/index";
import { buildUrl } from "../../utilities/index";
import HttpInterface from "../../helpers/HttpInterface";

export class StoreIntegrationsService {
  constructor() {
    this.httpProxy = new HttpInterface();
  }

  all(params = {}) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      buildUrl(`${API_BASE_URL}/logistic-service/store-integrations`, params),
      requestOptions
    );
  }

  get(id) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/store-integrations/${id}`,
      requestOptions
    );
  }

  create(storeIntegration) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(storeIntegration),
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/store-integrations`,
      requestOptions
    );
  }

  edit(storeIntegration) {
    const requestOptions = {
      method: "PUT",
      body: JSON.stringify(storeIntegration),
    };
    return this.httpProxy.fetch(
      API_BASE_URL +
        `/logistic-service/store-integrations/${storeIntegration.id}`,
      requestOptions
    );
  }

  delete(id) {
    const requestOptions = {
      method: "DELETE",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/store-integrations/${id}`,
      requestOptions
    );
  }
}
